import { Store } from '../config/types';

export const getStoreFromUrl = (): string | null =>
  new URLSearchParams(window.location.search).get('store');

export const getStoreFromStorage = (): string | null =>
  localStorage.getItem('lastVisitedStore');

export const saveStoreToStorage = (code: string) =>
  localStorage.setItem('lastVisitedStore', code);

/** выбрать первый магазин из загруженного списка */
export const getFirstStore = (stores: Store[]): string =>
  stores.length ? stores[0].code : '';

/** универсальный “поиск” дефолт-кода */
export const pickDefaultStore = (stores: Store[]): string => {
  const first = getFirstStore(stores);
  const url   = getStoreFromUrl();
  const last  = getStoreFromStorage();

  const exist = (code: string | null) =>
    code && stores.some((s) => s.code === code);

  if (exist(url)) {
    saveStoreToStorage(url!);
    return url!;
  }
  if (exist(last)) return last!;
  saveStoreToStorage(first);
  return first;
};
